import { Branded } from 'types/generics/brand'

/**
 * Formatted as YYYY
 */
export type YearString = Branded<string, 'YearString'>

/**
 * Milliseconds since the Unix epoch
 * See here: https://en.wikipedia.org/wiki/Unix_time
 */
export type UnixTime = Branded<number, 'UnixTime'>

/** Returns the current time as a branded UnixTime value. */
export function unixTimeNow(): UnixTime {
  return Date.now() as UnixTime
}
